import React from 'react';
import '../../assets/css/Modal.css';
import close from '../../assets/icons/close.svg';
const PaymentChoiceModal = ({ onClose, onYes, onNo, disabled }) => {


    return (
        <div className="modal-overlay">
            <div className="modal-content-success payment-choice-modal">
                <div className="modal-header-content" style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    marginBottom: '10px'
                }}>
                    <h5 style={{ color: '#7F56DA', margin: 0,fontSize:'16px' }}>Which payment mode do you prefer for submitting the Provisional Admission Form?</h5>
                    {/* <button className="close-btn" onClick={onClose}>
                        <img src={close} alt="close" />
                    </button> */}
                </div>
                <div className="modal-body" style={{ overflowY: 'hidden' }}>
                    <div className="text-center mt-5">
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '50px', flexWrap: 'wrap' }}>
                            <button className="add-btn"  onClick={onYes} disabled={disabled}>Digital Payment</button>
                            <button className="add-btn"    style={{ backgroundColor: '#ff4d4f', color: '#fff' }} onClick={onNo}>Admission Counter</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default PaymentChoiceModal;
